import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { ServicioService } from "../services/servicio.services";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { auth, cambio, newContraseña } from 'app/models/ejemplo.model';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
interface FormModel {
  captcha?: string;
}
@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.css']
})
export class NewPasswordComponent implements OnInit {

  public cargando:any = false;
  constructor(private _servicios: ServicioService, private _router: Router) { }
  token: any;
  usuariodb: any;
  user:string="";
  email:string="";
  cliente:string = "";
  flag: any;
  loginForm = new FormGroup({
    user: new FormControl("",Validators.required),
    cliente: new FormControl("",Validators.required),
    email: new FormControl("",[Validators.required, Validators.email]),
    captcha: new FormControl("",Validators.required)
  });
  ngOnInit() {

    this.email = "";
    this.user = "";
    this.cliente="";
    this.loginForm.patchValue({
      
      user:this.user,
      cliente:this.cliente,
      email:this.email,
    });
  }

  cambio (e){
    this.cargando = true;
    var nueva = new newContraseña();
    nueva.user = this.user;
    nueva.cliente = this.cliente;
    nueva.email = this.email;
    e.preventDefault();
    this._servicios.nuevaContraseña(nueva).subscribe(
      result =>{
        this.cargando = false;
        // if(result == "usuario"){
        //   swal({
        //     title: 'Usuario no encontrado en sistema.',
        //     type: 'warning',
        //   });
        // }

        // if(result == "empresa"){
        //   swal({
        //     title: 'Empresa no encontrada en sistema.',
        //     type: 'warning',
        //   });
        // }

        if(result == "Error"){
          swal({
            title: 'Se ha producido un error en el sistema.',
            type: 'warning',
          });
        }

        // if(result == "email"){
        //   swal({
        //     title: 'E-mail no se encuentra en sistema o no coincide con el registrado.',
        //     type: 'warning',
        //   });
        // }
        // if(result == "emailmatch"){
        //   swal({
        //     title: 'E-mail no coincide con el registrado en sistema.',
        //     type: 'warning',
        //   });
        // }
        if(result== "envio exitoso"){
          // swal({
          //   title: 'se envió correo con contraseña temporal.',
          //   type: 'success',
          // })

          //
          swal({
            title: 'Se enviará mensaje a su correo registrado en sistema.',
            type: 'success',
            confirmButtonText: 'Ingresar',
            showLoaderOnConfirm: true,
            preConfirm: () => {
              
                this._router.navigateByUrl('starterview');
             
            },
            allowOutsideClick: false
          });
          //
          
        }else{
           swal({
            title: 'Se enviará mensaje a su correo registrado en sistema.',
            type: 'success',
          })
        }
      }
    );


  }

}



// WEBPACK FOOTER //
// ./src/app/new-password/new-password.component.ts